export default function getExtensionIcon ( ext ) {
	switch ( ext ) {
		case 'wmv':
		case 'mkv':
		case 'mov':
		case 'video':
		case 'avi':
		case 'mp4':
			return 'fal fa-file-video'

		case 'wav':
		case 'ogg':
		case 'audio':
		case 'mp3':
			return 'fal fa-file-audio'

		case 'pdf':
			return 'fal fa-file-pdf'

		case 'png':
		case 'jpg':
		case 'gif':
			return 'fal fa-file-image'

		case 'zip':
		case 'rar':
		case 'gzip':
		case 'tz':
			return 'fal fa-file-archive'

		case 'xlsx':
		case 'xls':
			return 'fal fa-file-excel'

		case 'docx':
		case 'doc':
			return 'fal fa-file-word'

		case 'pptx':
		case 'ppt':
			return 'fal fa-file-powerpoint'

		case 'youtube':
			return 'fab fa-youtube'

		case 'vimeo':
			return 'fab fa-vimeo'

		case 'webinar':
		case 'webcast':
		case 'wowza':
		case 'external_link':
			return 'fal fa-broadcast-tower'

		case 'opened':
		case 'closed':
		case 'live_class':
		case 'opened':
		case 'closed':
		case 'live_class_opened':
		case 'live_class_closed':
			return 'fal fa-phone-laptop'

		case 'scorm':
		case 'scorm_cloud':
			return 'fal fa-chalkboard-teacher'

		case 'html':
			return 'fal fa-code'

		case 'flash':
			return 'fal fa-bolt'

		case 'linkedin_slidshare':
			return 'fab fa-slideshare'

		case 'conventional_test':
		case 'restart_test':
		case 'restart_general_test':
		case 'block_general_test':
		case 'block_test':
			return 'fal fa-check-double'

		case 'evaluated_quiz':
		case 'unevaluated_quiz':
			return 'fal fa-ballot-check'

		case 'presential_event':
			return 'fal fa-users-class'

		case 'drag_and_drop':
		case 'drag_the_words':
		case 'fill_in_the_blanks':
		case 'find_the_pairs':
		case 'this_or_that':
		case 'true_or_false':
		case 'flashcards':
		case 'enigma':
			return 'fal fa-gamepad'

		default:
			return 'fal fa-file'
	}
}